module.exports = __webpack_public_path__ + "static/media/wifi-24px.e682ea2b.svg";